import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getBreadcrumb } from "../../utils/breadcrumb.utils";
import "../../assets/css/BreadcrumbStyle.css";

const Breadcrumb = () => {
  const { pathname } = useLocation();
  const breadcrumbs = getBreadcrumb(pathname);
  return (
    <div className="bg-gray-50 py-3 top-box-margin">
      <div className="container">
        <nav aria-label="breadcrumb">
          <ol
            className="breadcrumb mb-0"
            style={{ paddingLeft: 0 }}
          >
            {breadcrumbs.map((item, index) => {
              const isLast = index === breadcrumbs.length - 1;

              return (
                <li key={item.path} className={`breadcrumb-item ${isLast ? "active" : ""}`} >
                  {isLast ? (
                    item.name
                  ) : (
                    <Link to={item.path} className="text-gray-700 text-decoration-none hover:underline" >
                      {item.name}
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </div>
    </div>
  );
};
export default Breadcrumb;